import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// import Routes from '../../../../Layout/Routes'
import {
    CommunityLeadGetUserApi, CommunityLeadGetUserBusinessApi,
    CommunityLeadGetUserAddressApi, CommunityLeadGetUserLoanApi,
    CommunityLeadGetUserBankApi, getUploadedDocumentsfApi, CommunityLeadGetUserSalaryApi, CommunityLeadGetUserPropertyByUserIdApi, CommunityLeadGetUserDirectorByUserIdApi, CommunityLeadSaveUserLoanApi, getStoryLines,
    generateCustomLink, getCustomLink, getCommunityPersonalApi
} from '../../CommunityActionCreator'
import moment from 'moment'
import CustomLinkPopup from '../../../Popups/CustomLinkPopup'
import CustomLinkPrevious from './CustomLinkPrevious'
import { BASE_URL } from '../../../api-factory'
import Alerts from '../../../Popups/SidePopup'
import { employmentTypeArr } from '../../../CommonUtils'
import copy from 'copy-to-clipboard'
import { Tooltip } from '@mui/material'
import './StoryLine.scss'

const LendersDetail = ({ rowData }) => {
    const [objectData, setObjectData] = useState({})
    const [copyPopup, setcopyPopup] = useState(false)
    const [msg, setmsg] = useState()
    // const [documentList, setDocumentList] = useState([])
    const [sourceOfIncome, setSourceOFIncome] = useState()
    const [communityData, setCommunityData] = useState()
    const navigate = useNavigate();
    const location = useLocation();
    const [personalData, setPersonalData] = useState({})
    const [buisnessData, setbuisnessData] = useState({})
    const [directorData, setdirectorData] = useState({})
    const [loanData, setloanData] = useState({})
    const [addressData, setaddressData] = useState({})
    const [bankdata, setbankdata] = useState({})
    const [salaryData, setSalaryData] = useState({})
    const [shareUrl, setShareUrl] = useState('')
    const [storyLineData, setStoryLineData] = useState()
    const [shareCompletionUrl, setShareCompletionUrl] = useState('')

    const [customLinkState, setCustomLinkState] = useState(false)
    const [customLinkPrevious, setCustomLinkPrevious] = useState(false)


    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [customLinkData, setCustomLinkData] = useState({})
    const [wordCount, setWordCount] = useState(0);
    const [editState, setEditState] = useState(false);

    const [loanId, setloanId] = useState('');
    let wordLimit = 500;

    useEffect(() => {


        if ((rowData !== null || rowData !== undefined) && !window.location.href.includes('external/loan/details/')) {
            getPersonalDetail()
            getBankDetail(objectData)
            getAddressDetail(objectData)
            getLoanDetail(objectData)
            console.log(objectData, "oooo");
            getStoryLineData(rowData ? rowData.loanId : '')

            if (rowData ? rowData.communityId : "" || rowData.communityId) {
                getCommunityByCommunityId()
            }
            // getDocumentDetail()


        }
        if (window.location.href.includes('/external/loan/details/')) {
            getPersonalDetail()
            getBankDetail()
            getAddressDetail()
            getLoanDetail()
            if (rowData.communityId) {
                getCommunityByCommunityId()
            }
            // createUrl()
        }
        if (rowData.linkId) {
            getCustomLink(rowData.linkId, callBack => {
                if (callBack) {
                    setCustomLinkData(callBack.data)
                }
            }, error => {

            })
        }
        if (rowData.loanId) {
            setloanId(rowData.loanId)
        }

    }, [])


    const createUrl = () => {
        if (personalData.userId && loanData.loanId) {
            let url = BASE_URL === 'https://testbackend.credhub.in' || BASE_URL === 'http://localhost:8050' ? 'http://34.139.202.55' : 'https://credhub.in'
            let updatedUrl = url + '/external/loan/details/' + personalData.userId + '/' + loanData.loanId + '/'
            let commId = communityData && communityData.communityId ? communityData.communityId : "S5JzvAGhG4d0q7fPpBL9150Y"
            setShareUrl(updatedUrl + commId)
            console.log("share loan link ", updatedUrl + commId);
            NewCopy(updatedUrl + commId, 'Share Link is Copied to the Clipboard');
        }
    }
    const createCompletionUrl = () => {
        if (personalData.userId && loanId) {
            let url = BASE_URL === 'https://testbackend.credhub.in' || BASE_URL === 'http://localhost:8050' ? 'http://34.139.202.55' : 'https://credhub.in'
            let updatedUrl = url + '/external/add/loan/details/' + personalData.userId + '/' + loanId
            setShareCompletionUrl(updatedUrl)
            console.log("complete loan link  ", updatedUrl);
            NewCopy(updatedUrl, 'Loan Completion Link is Copied to the Clipboard')
        }
    }

    const getStoryLineData = (loanId) => {
        if (loanId) {
            getStoryLines(loanId, 1, 100, callback => {
                setStoryLineData(callback.data)
            }, error => {

            })
        }
    }

    const actionCustomLink = (type) => {
        if (type === "generate") {
            setCustomLinkState(true)
        }
        else {
            setCustomLinkPrevious(true)
        }
    }

    const getPropertyDetails = (data) => {
        CommunityLeadGetUserPropertyByUserIdApi(rowData.userId,
            callBack => {
                if (Object.keys(callBack).length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    Object.keys(callBack).forEach(key => {
                        changeObjectData[key] = callBack[key]
                    })
                    setObjectData(changeObjectData)
                    getAddressDetail(changeObjectData)
                }
            }, error => {

            })
    }

    const inputChange = (e, type) => {

        if (type === 'loanProposal') {
            const tempVal = e.target.value;
            setWordCount(tempVal.length)
            if (tempVal.length < wordLimit) {
                loanData.loanProposal = tempVal
                setloanData(loanData)
            } else {
                loanData.loanProposal = tempVal.substring(0, wordLimit)
                setloanData(loanData)
                setWordCount(wordLimit)
            }
        }
    }
    const getSalariedDetail = (data) => {
        CommunityLeadGetUserSalaryApi(rowData.userId,
            callBack => {
                if (Object.keys(callBack.data).length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    Object.keys(callBack.data).forEach(key => {
                        changeObjectData[key] = callBack.data[key]
                    })
                    setSalaryData(changeObjectData)
                    setObjectData(changeObjectData)
                    getAddressDetail(changeObjectData)

                }
            }, error => {

            })
    }
    // const getDocumentDetail = (data) => {
    //     getUploadedDocumentsApi(location.state.rowData.userId ? location.state.rowData.userId : rowData.userId, callBack => {
    //         setDocumentList(callBack)
    //     })
    // }
    const getPersonalDetail = () => {
        CommunityLeadGetUserApi(rowData.userId,
            callBack => {
                if (Object.keys(callBack).length > 0) {
                    let changeObjectData = Object.assign({}, objectData)
                    Object.keys(callBack).forEach(key => {
                        changeObjectData[key] = callBack[key]
                    })

                    setObjectData(changeObjectData)
                    setPersonalData(changeObjectData)
                    // console.log(changeObjectData, "changeObjectData")
                    CommunityLeadGetUserLoanApi(rowData.loanId,
                        callBack => {
                            setSourceOFIncome(callBack.sourceOfIncome)
                            if (callBack.sourceOfIncome === employmentTypeArr[1].code) {
                                setSourceOFIncome('salary')
                                getSalariedDetail(changeObjectData)
                            } else {
                                if (callBack.sourceOfIncome === employmentTypeArr[0].code) {

                                    getBusinessDetail(changeObjectData)
                                }
                                if (callBack.sourceOfIncome === employmentTypeArr[2].code) {
                                    getPropertyDetails(changeObjectData)
                                }
                            }
                        })
                }
            }, error => {

            })
    }

    const getBusinessDetail = (data) => {

        CommunityLeadGetUserBusinessApi(rowData.userId,
            callBack => {
                if (callBack) {
                    if (Object.keys(callBack).length > 0) {
                        let changeObjectData = Object.assign({}, data)
                        Object.keys(callBack).forEach(key => {
                            if (key === 'name') {
                                changeObjectData['businessName'] = callBack[key]
                            } else {
                                changeObjectData[key] = callBack[key]
                            }
                        })
                        setbuisnessData(changeObjectData)
                        setObjectData(changeObjectData)
                        getDirectorDetails(changeObjectData)

                        // getAddressDetail(changeObjectData)

                    }
                } else {
                    getDirectorDetails(objectData)

                }

            }, error => {

            })


    }

    const getAddressDetail = (data) => {
        CommunityLeadGetUserAddressApi(rowData.userId,
            callBack => {
                if (callBack.length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    callBack.forEach(row => {
                        Object.keys(row).forEach(key => {
                            if (!key.includes('Perm')) {
                                if (row.addressType === "current") {
                                    changeObjectData[key] = row[key]
                                }

                                if (row.addressType === "permanent") {
                                    changeObjectData[key + 'Perm'] = row[key]
                                }
                                if (row.addressType === "organization") {
                                    changeObjectData[key + 'Org'] = row[key]
                                }
                            }
                        })
                    })
                    setaddressData(changeObjectData)
                    setObjectData(changeObjectData)
                    getBankDetail(changeObjectData)
                }
            }, error => {

            })
    }

    const getBankDetail = (data) => {
        CommunityLeadGetUserBankApi(rowData.userId,
            callBack => {
                let changeObjectData = Object.assign({}, data)
                if (Object.keys(callBack).length > 0) {
                    Object.keys(callBack).forEach(key => {
                        changeObjectData[key] = callBack[key]
                    })
                }
                setbankdata(changeObjectData)
                setObjectData(changeObjectData)
                getLoanDetail(changeObjectData)
            }, error => {

            })

    }

    const getLoanDetail = (data) => {

        CommunityLeadGetUserLoanApi(rowData.loanId,
            callBack => {
                let changeObjectData = Object.assign({}, data)
                if (Object.keys(callBack).length > 0) {
                    Object.keys(callBack).forEach(key => {
                        changeObjectData[key] = callBack[key]
                    })
                }
                console.log("loaaaaaannnn ", changeObjectData);
                setWordCount(callBack && callBack.loanProposal ? callBack.loanProposal.length : '')
                setloanData(changeObjectData)

                setObjectData(changeObjectData)
            }, error => {

            })

    }
    const getDirectorDetails = (data) => {
        CommunityLeadGetUserDirectorByUserIdApi(rowData.userId,
            callBack => {
                if (callBack) {
                    if (Object.keys(callBack).length > 0) {
                        let changeObjectData = Object.assign({}, data)
                        Object.keys(callBack).forEach(key => {
                            // if (key === 'name') {
                            //     changeObjectData['businessName'] = callBack[key]
                            // } else {
                            changeObjectData[key] = callBack[key]
                            // }
                        })
                        setdirectorData(changeObjectData)
                        setObjectData(changeObjectData)
                        getAddressDetail(changeObjectData)
                    }
                } else {
                    setdirectorData('')

                }
            }, error => {

            })
    }

    const saveHandler = (e) => {
        if (e === 'close') {
            // navigate(Routes.SUPER_ADMIN_COMMUNITY_PAGE)
        }
    }
    const removePopup = () => {
        setTimeout(
            function () {
                setcopyPopup(false)
            }.bind(this),
            5000
        );
    }
    const copyFunction = (type) => {
        if (type === 'esign') {
            var copyText = document.getElementById("myInput");
            navigator.clipboard.writeText(copyText.innerHTML);
            setmsg('Esign Link is Copied')
            setcopyPopup(true)
            removePopup()
        }
        if (type === 'enach') {
            var copyText = document.getElementById("myInputEnach");
            navigator.clipboard.writeText(copyText.innerHTML);
            setmsg('Enach Link is Copied')
            setcopyPopup(true)
            removePopup()
        }
    }
    const NewCopy = (data, msg) => {
        copy(data)
        setmsg(msg)
        setcopyPopup(true)
        removePopup()
    }
    const getCommunityByCommunityId = () => {
        getCommunityPersonalApi(rowData ? rowData.communityId : rowData.communityId, callBack => {
            setCommunityData(callBack)
        })
    }
    const customLinkHandler = (data, action) => {
        if (action === "close") {
            setCustomLinkState(false)
        } else if (action === "save") {
            let url = BASE_URL === 'https://testbackend.credhub.in' || BASE_URL === 'http://localhost:8050' ? 'http://34.139.202.55' : 'https://credhub.in'
            let updatedUrl = url + '/external/loan/details/' + personalData.userId + "/"
            data.loanId = loanId
            data.url = updatedUrl
            generateCustomLink(data, callBack => {
                if (callBack.message === "success") {
                    updatedUrl = callBack.data.url
                    forceUpdate()
                    console.log("custom loan link  ", updatedUrl);
                    NewCopy(updatedUrl, 'Custom URL is Copied to the Clipboard')
                    setCustomLinkState(false)
                }
            }, error => {

            })
        }
    }
    const customLinkPreviousHandler = () => {
        setCustomLinkPrevious(false)
    }

    const maskingFunction = (value) => {
        if (value) {
            let subNum = value.toString().substring(0, 5)
            for (let index = 5; index < value.toString().length; index++) {
                if (value.toString().length > 15 && index % 6 == 0) {
                    subNum = subNum + ' '
                }
                subNum = subNum + "X"
            }
            return subNum
        }
    }

    const proposalEnter = () => {
        CommunityLeadSaveUserLoanApi(loanData, callBack => {
            getLoanDetail()
            setEditState(false)
        }, error => {

        })
    }

    return (
        <div className='container-fluid'>
            {
                customLinkState ?
                    <CustomLinkPopup handler={customLinkHandler} ></CustomLinkPopup> : ""
            }
            {
                customLinkPrevious ?
                    <CustomLinkPrevious handler={customLinkPreviousHandler} loanId={loanId}></CustomLinkPrevious> : ''
            }
            {/* {communityData && communityData.name ? */}
            {communityData && communityData.name && window.location.href.includes('/admin') ?
                <div className='row'>
                    <div className='col-sm-12 col-xs-12'>
                        <div className="profile-details-box-new" style={{ minHeight: '150px' }}>
                            <div className="new-basic-head" >Community Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row' >
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Name</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{communityData.name}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Mobile No
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{communityData.mobileNumber}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Email Id
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>

                                        <div style={{ fontSize: '14px' }}> <b>{communityData.email}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Community Code
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{communityData.communityCode}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : ""}
            {
                !window.location.href.includes('/external') ?
                rowData ? !rowData.communityId ?
                        <div className='row'>
                            <h3>B2C Lead</h3>
                        </div>
                        : ""
                        : rowData.communityId ? <div className='row'>
                            <h3>B2C Lead</h3>
                        </div> : ""
                    : ""
            }

            <div className='row'>
                <div className="col-sm-6 col-xs-12">
                    <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                        <div className="new-basic-head" >Personal Details</div>
                        <div style={{ padding: '10px' }}>

                            <div className='row' >
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Name</label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{personalData.name}</b></div>
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Mobile No
                                    </label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(personalData.mobileNo) : personalData.mobileNo}</b></div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Aadhaar No
                                    </label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(personalData.aadharNo) : personalData.aadharNo}</b></div>
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Date Of Birth
                                    </label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>

                                    <div style={{ fontSize: '14px' }}> <b>{moment(personalData.dob).format('DD-MM-YYYY')}</b></div>
                                </div>
                            </div>
                            <div className='row'>

                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Pan No</label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(personalData.panNo) : personalData.panNo}</b></div>
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Name on PAN</label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{personalData.nameOnPan}</b></div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Email Id
                                    </label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(personalData.emailId) : personalData.emailId}</b></div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                {loanData && loanData.loanAmount !== 0 ?
                    <div className='col-sm-6 col-xs-12'>
                        <div className="profile-details-box-new " style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Loan Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Amount</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.loanAmount}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Tenure (in months)</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.tenurePeriod}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Approved Amount</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.approvedAmount}</b></div>
                                    </div>
                                    <div className='col-sm-3 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}> Source Of Income</label>
                                    </div>
                                    <div className='col-sm-3 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{sourceOfIncome === 'businessprofessionalincome' ? 'Buisness' : sourceOfIncome}</b></div>
                                    </div>

                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400'}}> Approved Tenure</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.approvedTenurePeriod}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}> Loan Type</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.loanType && loanData.loanType === 'homeloan' ? 'Home Loan' : loanData.loanType === 'personalloan' ? 'Personal Loan' : loanData.loanType === 'lap' ? 'LAP(Loan Against Property)' : loanData.loanType === 'businessloan' ? 'Business Loan' : ""}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}> Loan Status</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{rowData && rowData.loanStatus ? rowData.loanStatus : "Not Found!!"}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Loan Segment</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.loanSegment}</b></div>
                                    </div>

                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}> Expected Range of Interest (Minimum)</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12' style={{ marginTop: '30px' }}>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.expLowerRangeOfInterest}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Expected Range of Interest (Maximum)</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12' style={{ marginTop: '30px' }}>
                                        <div style={{ fontSize: '14px' }}> <b>{loanData.expUpperRangeOfInterest}</b></div>
                                    </div>

                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12' >
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Loan Description</label>
                                    </div>
                                    <div className='col-sm-10 col-xs-12'>
                                        {
                                            editState === true ?
                                                <div className="col-sm-12 col-xs-12 "  >
                                                    <textarea
                                                        placeholder="Enter Loan Description here..."
                                                        name="description"
                                                        size={'small'}
                                                        type='text'
                                                        style={{ height: '110px', width: '100%' }}
                                                        required={true}
                                                        value={loanData.loanProposal}
                                                        onChange={e => inputChange(e, 'loanProposal')}
                                                    />
                                                    {wordCount === wordLimit ? <h6 className="form-text text-danger"><b>{wordCount}/{wordLimit}</b></h6> :
                                                        <h6 className="form-text text-success"><b>{wordCount}/{wordLimit}</b></h6>}
                                                    <div className='text-center'>
                                                        <button className='cred-btn text-center' onClick={e => setEditState(false)}>Close</button>
                                                        <button className='cred-btn text-center' onClick={e => proposalEnter()}>Save</button>
                                                    </div>
                                                </div>
                                                : <Tooltip title="You can tap once on the text to edit the description!"><div style={{ fontSize: '14px' }} > <b onClick={e => setEditState(true)}>{loanData.loanProposal}</b></div></Tooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
                {sourceOfIncome === employmentTypeArr[1].code && salaryData && salaryData.monthlySalary ?

                    <div className="col-sm-6 col-xs-12">
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Salaried Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row' >
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Organization Name</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{salaryData.nameOfOrganisation}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Monthly Salary
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{salaryData.monthlySalary}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Salary Day</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{salaryData.salaryDay}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Joining Date
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{moment(salaryData.joiningDate).format('DD-MM-YYYY')}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Total Experience
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{salaryData.totalExperience}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Designation
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{salaryData.designation}</b></div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    : ""}
                {sourceOfIncome === employmentTypeArr[0].code && buisnessData && buisnessData.typeOfConsititution ?
                    <div className="col-sm-12 col-xs-12">
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Buisness Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row' >

                                    {buisnessData.gstNo ?
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>GST Number</label>
                                        </div>
                                        : ""}
                                    {buisnessData.gstNo ?
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(buisnessData.gstNo) : buisnessData.gstNo}</b></div>
                                        </div>
                                        : ""}
                                    {buisnessData.gstRegistrationCertificate ?
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>GST Registration Certificate
                                            </label>
                                        </div>
                                        : ""}
                                    {buisnessData.gstRegistrationCertificate ?
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '14px' }}> <b>{buisnessData.gstRegistrationCertificate === true ? <i className='fa fa-check' style={{ color: 'green' }}></i> : <i style={{ color: 'red' }} className='fa fa-close'></i>}</b></div>
                                        </div>
                                        : ""}
                                </div>
                                <div className='row'>
                                    {buisnessData.msmeAvailable ?
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>MSME Available</label>
                                        </div>
                                        : ""}
                                    {buisnessData.msmeAvailable ?
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '14px' }}> <b>{buisnessData.msmeAvailable === true ? <i className='fa fa-check' style={{ color: 'green' }}></i> : <i style={{ color: 'red' }} className='fa fa-close'></i>}</b></div>
                                        </div>
                                        : ""}
                                    {buisnessData.orgPanNo ?
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Organisation PAN Number
                                            </label>
                                        </div>
                                        : ""}
                                    {buisnessData.orgPanNo ?
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(buisnessData.orgPanNo) : buisnessData.orgPanNo}</b></div>
                                        </div>
                                        : ""}
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Quaterly Turnover
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{buisnessData.quaterlyTurnover}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Last Year Turnover
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{buisnessData.lastYearTurnover}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {buisnessData.tradeLicenseNoOrMSME ?
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Trade License No. Or MSME
                                            </label>
                                        </div>
                                        : ""}
                                    {buisnessData.tradeLicenseNoOrMSME ?
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '14px' }}> <b>{buisnessData.tradeLicenseNoOrMSME}</b></div>
                                        </div>
                                        : ""}
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Type Of Business
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{buisnessData.typeOfBusiness}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Type Of Consititution
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{buisnessData.typeOfConsititution}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Business Description
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        {buisnessData.businessDesc && buisnessData.businessDesc.length > 40 ?
                                            <div className='text-center' tyle={{ fontSize: '14px' }} data-toggle="tooltip" data-placement="top" title={buisnessData.businessDesc}>
                                                <b>{buisnessData.businessDesc.length > 40 ? buisnessData.businessDesc.slice(0, 10) + '....' : buisnessData.businessDesc}</b>
                                            </div>
                                            : <div style={{ fontSize: '14px' }}> <b>{buisnessData.businessDesc}</b></div>}                                            </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>Date of Incorporation
                                        </label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}><b>{moment(buisnessData.dateOfIncorporation).format('DD-MM-YYYY')}</b></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
                {sourceOfIncome === employmentTypeArr[2].code && objectData.data ?
                    <div className="col-sm-6 col-xs-12">
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Property Details</div>
                            <div style={{ padding: '10px' }}>
                                {objectData.data.map((data, i) => {
                                    return (
                                        <div key={i}>
                                            <div className='row' >
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Address</label>
                                                </div>
                                                <div className='col-sm-3 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(data.address) : data.address}</b></div>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>City</label>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{data.city}</b></div>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>State</label>
                                                </div>
                                                <div className='col-sm-1 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{data.state}</b></div>
                                                </div>
                                            </div>
                                            <div className='row' >
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>pincode</label>
                                                </div>
                                                <div className='col-sm-3 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{data.pincode}</b></div>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Rental Income</label>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px' ,fontWeight:'400'}}>{data.rentalIncome}</label>
                                                </div>

                                            </div>
                                            <hr />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    : ""}
                {sourceOfIncome === employmentTypeArr[0].code && directorData.data ?
                    <div className="col-sm-6 col-xs-12">
                        <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                            <div className="new-basic-head" > Director Details</div>
                            <div style={{ padding: '10px' }}>

                                {directorData.data && directorData.data.map((data, gv) => {
                                    return (
                                        <div key={gv}>
                                            <div className='row' >
                                                <div className='col-sm-1 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Name</label>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{data.name}</b></div>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>   PAN Number</label>
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(data.panNumber) : data.panNumber}</b></div>

                                                    {/* <div style={{ fontSize: '14px' }}> <b>{data.panNumber}</b></div> */}
                                                </div>
                                                <div className='col-sm-2 col-xs-12'>
                                                    <label className='' style={{ fontSize: '14px',fontWeight:'400' }}>Aadhaar Number</label>
                                                </div>
                                                <div className='col-sm-1 col-xs-12'>
                                                    <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(data.aadharNumber) : data.aadharNumber}</b></div>
                                                </div>
                                            </div>
                                            <hr />

                                        </div>

                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    : ""}
                {addressData && addressData.address ?
                    <div className='col-sm-6 col-xs-12'>
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Current Address Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px' ,fontWeight:'400'}}>Address</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(addressData.address) : addressData.address}</b></div>

                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px' ,fontWeight:'400'}}>City</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.city}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>State</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.state}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>Pincode</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.pincode}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
                {addressData && addressData.addressPerm ?
                    <div className='col-sm-6 col-xs-12'>
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Permanent Address Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row'>
                                    <div className='col-xs-12 col-sm-2'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>Address</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(addressData.addressPerm) : addressData.addressPerm}</b></div>
                                    </div>
                                    <div className='col-xs-12 col-sm-2'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>City</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.cityPerm}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-xs-12 col-sm-2'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>State</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.statePerm}</b></div>
                                    </div>
                                    <div className='col-xs-12 col-sm-2'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>Pincode</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.pincodePerm}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
                {sourceOfIncome === 'salary' && addressData && addressData.addressOrg ?
                    <div className='col-sm-6 col-xs-12'>
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Organisation Address Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>Address</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{customLinkData && customLinkData.dataMask === true ? maskingFunction(addressData.addressOrg) : addressData.addressOrg}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px',fontWeight:'400' }}>City</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.cityOrg}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px' ,fontWeight:'400'}}>State</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.stateOrg}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label style={{ fontSize: '14px' ,fontWeight:'400'}}>Pincode</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{addressData.pincodeOrg}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}

                {
                    storyLineData && storyLineData.length > 0 ?
                        <div className='col-sm-6 col-xs-12'>
                            <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                                <div className="new-basic-head" >Story Line</div>
                                <div style={{ maxHeight: '500px', overflow:'overlay' }}>

                                    <div className="table-container">
                                        <table className="table table-filter">
                                            <tbody>
                                                {
                                                    storyLineData.map((data, i) => {
                                                        return (
                                                            <tr data-status="pagado">
                                                                <td>
                                                                    <div className="media">
                                                                        <div className="media-body">
                                                                            <span className="media-meta pull-right">{moment(data.date).format('MMMM DD YYYY')}</span>
                                                                            <h4 className="title">
                                                                                {data.addedBy}
                                                                            </h4>
                                                                            <h5 className="summary">{data.content}</h5>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}



                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''}
                {

                    window.location.href.includes('/admin') && loanId ?
                        <div className='mb-3 row'>
                            <div className="col-12 text-center">
                                <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => actionCustomLink("generate")}>  Generate Link </button>
                                <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => actionCustomLink("previous")}>  Previously Generated Links </button>

                                <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => createCompletionUrl()}>   <i className='fa fa-copy' style={{
                                    fontSize: '20px', color: 'gray', cursor: 'pointer', float: "right",
                                    marginTop: '2px', marginLeft: '10px'
                                }}></i>Copy Loan Completion Link  </button>
                            </div>
                        </div> : ""
                }

                {/* {bankdata && bankdata.data ?
                    <div className='col-sm-6 col-xs-12'>
                        <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                            <div className="new-basic-head" > Account Details</div>
                            <div style={{ padding: '10px' }}>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>Acc Number</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.accNumber}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>Bank Name</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.bank}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>Branch</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.branch}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>IFSC</label>

                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.ifsc}</b></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>Name in bank</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.nameInBank}</b></div>
                                    </div>
                                    <div className='col-sm-2 col-xs-12'>
                                        <label className='' style={{ fontSize: '14px' }}>Account Type</label>
                                    </div>
                                    <div className='col-sm-4 col-xs-12'>
                                        <div style={{ fontSize: '14px' }}> <b>{bankdata.accountType}</b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""} */}

                {/* {objectData&& objectData.loanId?
                <div className='col-sm-6 col-xs-12'>
                    <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                        <div className="new-basic-head" > Links</div>
                        <div style={{ padding: '10px' }}>
                            <div className='row'>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px' }}>Esign Link :</label>
                                </div>
                                <div className='col-sm-10 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b id='myInput'>{BASE_URL.split('/')[0] + '//' + window.location.href.split('/')[2] + '/esign/' + objectData.loanId}  </b>&nbsp; &nbsp;<i className='fa fa-copy' style={{ fontSize: '18px', color: 'green', cursor: 'pointer' }} onClick={() => NewCopy(BASE_URL.split('/')[0] + '//' + window.location.href.split('/')[2] + '/esign/' + objectData.loanId)}></i></div>
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '14px' }}>Enach Link :</label>
                                </div>
                                <div className='col-sm-10 col-xs-12'>
                                    <div style={{ fontSize: '14px' }}> <b id='myInputEnach'>{BASE_URL.split('/')[0] + '//' + window.location.href.split('/')[2] + '/enach/' + objectData.loanId}  </b>&nbsp; &nbsp;<i className='fa fa-copy' style={{ fontSize: '18px', color: 'green', cursor: 'pointer' }} onClick={() => NewCopy(BASE_URL.split('/')[0] + '//' + window.location.href.split('/')[2] + '/enach/' + objectData.loanId)}></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :""} */}

            </div>
            {/* <div className='row'>
                    {documentList && documentList.length > 0 ?
                        <div className='col-sm-12 col-xs-12'>
                            <div className="profile-details-box-new" style={{ minHeight: "300px" }}>
                                <div className="new-basic-head" > Document Details</div>
                                <div style={{ padding: '10px' }}>
                                    <div className='row'>
                                        {documentList.map((data, i) => {
                                            console.log(data)
                                            if (data.documentUrl) {
                                                const fileExtensionAndPrefix = getExtensionAndUrlPrefixFromName(data.documentUrl)
                                                const fileExtension = fileExtensionAndPrefix.extension
                                                const url = fileExtensionAndPrefix.urlPrefix + fileExtension + ";base64," + encodeURI(data.documentInString)
                                                return (
                                                    <div className='col-sm-2 col-xs-12 document-pdf text-center' key={i}>
                                                        <div className='document-box'>
                                                            <a href={data.documentUrl} target='_blank'>  <h6 className='text-center' ><b>{data.documentName}</b></h6></a>
                                                            {console.log(data.documentUrl)}
                                                            {data.documentUrl.includes('pdf') ?
                                                                <PDFReader url={url} showAllPage={true} />

                                                                // <iframe src={data.documentUrl} ></iframe>
                                                                : <img src={url} alt="" width='100%' />}
                                                        </div>
                                                        <br />
                                                    </div>
                                                )
                                            }

                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ""}
                </div>
 */}
            {/* </div> */}
            {copyPopup ?
                <Alerts msg={msg} />
                : ""}
        </div>
    )
}

export default LendersDetail;